// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connector-selection {
  min-height: calc(100vh - 140px);
  padding: 40px;
  background: #f8fafc;
}

.connector-selection-header {
  text-align: center;
  margin-bottom: 40px;
}

.connector-selection-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.connector-selection-header p {
  font-size: 16px;
  color: #6b7280;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.connector-options {
  max-width: 800px;
  margin: 0 auto 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.connector-card {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.connector-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.connector-card.selected {
  border-color: #3b82f6;
  background: #eff6ff;
}

.connector-checkbox input {
  width: 20px;
  height: 20px;
  accent-color: #3b82f6;
}

.connector-content {
  flex: 1 1;
}

.connector-logos {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.connector-logo img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.connector-arrow {
  color: #6b7280;
}

.connector-details h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.connector-details p {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}

.connector-actions {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.next-button {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.next-button:hover:not(:disabled) {
  background: #2563eb;
}

.next-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

/* Existing connectors styles */
.existing-connectors-list {
  max-width: 800px;
  margin: 0 auto 40px;
}

.existing-connector-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.connector-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.connector-details h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.connector-details p {
  font-size: 14px;
  color: #6b7280;
}

.connector-actions {
  display: flex;
  gap: 12px;
}

.manage-btn {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.settings-btn {
  background: white;
  border: 1px solid #e5e7eb;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  color: #6b7280;
}

.add-connector-section {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.add-connector-btn {
  background: white;
  border: 2px dashed #d1d5db;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto;
  transition: all 0.2s;
}

.add-connector-btn:hover {
  border-color: #9ca3af;
  color: #374151;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector/components/ConnectorSelection.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".connector-selection {\n  min-height: calc(100vh - 140px);\n  padding: 40px;\n  background: #f8fafc;\n}\n\n.connector-selection-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.connector-selection-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 12px;\n}\n\n.connector-selection-header p {\n  font-size: 16px;\n  color: #6b7280;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.connector-options {\n  max-width: 800px;\n  margin: 0 auto 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.connector-card {\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 24px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.connector-card:hover {\n  border-color: #d1d5db;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.connector-card.selected {\n  border-color: #3b82f6;\n  background: #eff6ff;\n}\n\n.connector-checkbox input {\n  width: 20px;\n  height: 20px;\n  accent-color: #3b82f6;\n}\n\n.connector-content {\n  flex: 1;\n}\n\n.connector-logos {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.connector-logo img {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n}\n\n.connector-arrow {\n  color: #6b7280;\n}\n\n.connector-details h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 8px;\n}\n\n.connector-details p {\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n.connector-actions {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.next-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.next-button:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.next-button:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Existing connectors styles */\n.existing-connectors-list {\n  max-width: 800px;\n  margin: 0 auto 40px;\n}\n\n.existing-connector-card {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.connector-info {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.connector-details h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 4px;\n}\n\n.connector-details p {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.connector-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.manage-btn {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.settings-btn {\n  background: white;\n  border: 1px solid #e5e7eb;\n  padding: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #6b7280;\n}\n\n.add-connector-section {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.add-connector-btn {\n  background: white;\n  border: 2px dashed #d1d5db;\n  padding: 16px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  color: #6b7280;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 auto;\n  transition: all 0.2s;\n}\n\n.add-connector-btn:hover {\n  border-color: #9ca3af;\n  color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
